// extracted by mini-css-extract-plugin
export default {"sider":"surveyresultspage_sider__vRUVt","logo":"surveyresultspage_logo__+kQRg","titleLink":"surveyresultspage_titleLink__5eyJA"};